import { useMemo } from 'react';
import { getFiGrowthBook, useIsGrowthBookEnabled } from '../lib/growthbook';

/**
 * Determines if the new CartItemV2 component should be shown for all bundle items.
 * Can be disabled via GrowthBook flag 'enable-cart-item-v2' (defaults to true).
 */
export default function useCartItemV2Enabled(): boolean {
  const isGrowthBookEnabled = useIsGrowthBookEnabled();

  return useMemo(() => {
    return isGrowthBookEnabled ? getFiGrowthBook().getFeatureValue<boolean>('enable-cart-item-v2', true) : true;
  }, [isGrowthBookEnabled]);
}
